import { statisticsRequest } from '@/services/statistics.service'
import type { IStatistics } from '@/store/models/statistics.model'
import { put, takeEvery } from 'redux-saga/effects'
import { StatisticsConst } from '@/store/constant/statistics.constant'
import { getStatistics } from '@/store/actions/statistics.action'
import { requestStatus, requestFail } from '@/store/actions/common.action'

function* handleStatistics(): unknown {
    try {
        const response: IStatistics = yield statisticsRequest()
        yield put(getStatistics(response))
        yield put(requestStatus(false))
    } catch (error: any) {
        yield put(requestFail(error.response.data.error))
    }
}

export default function* statisticsSaga(): unknown {
    yield takeEvery(StatisticsConst.GET_STATISTICS, handleStatistics)
}